/**
 * Define and Export Action Types
 */

export const VIEW_CREATE_REQUEST = 'VIEW_CREATE_REQUEST'
export const VIEW_CREATE_RECEIVE = 'VIEW_CREATE_RECEIVE'
export const VIEW_CREATE_FAILURE = 'VIEW_CREATE_FAILURE'
export const VIEW_REORDER_REQUEST = 'VIEW_REORDER_REQUEST'
export const VIEW_REORDER_RECEIVE = 'VIEW_REORDER_RECEIVE'
export const VIEW_REORDER_FAILURE = 'VIEW_REORDER_FAILURE'
export const VIEW_RENAME_REQUEST = 'VIEW_RENAME_REQUEST'
export const VIEW_RENAME_RECEIVE = 'VIEW_RENAME_RECEIVE'
export const VIEW_RENAME_FAILURE = 'VIEW_RENAME_FAILURE'
export const VIEW_UPDATE_COLUMNS_REQUEST = 'VIEW_UPDATE_COLUMNS_REQUEST'
export const VIEW_UPDATE_COLUMNS_RECEIVE = 'VIEW_UPDATE_COLUMNS_RECEIVE'
export const VIEW_UPDATE_COLUMNS_FAILURE = 'VIEW_UPDATE_COLUMNS_FAILURE'
export const VIEW_DELETE_REQUEST = 'VIEW_DELETE_REQUEST'
export const VIEW_DELETE_RECEIVE = 'VIEW_DELETE_RECEIVE'
export const VIEW_DELETE_FAILURE = 'VIEW_DELETE_FAILURE'
